var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('audio-icon'),_c('div',{staticClass:"container-text"},[_c('p',[_vm._v(_vm._s(_vm.text))]),_c('img',{attrs:{"src":require("@game/assets/img/arrow.png"),"alt":""},on:{"click":_vm.onClick}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }